import { render, staticRenderFns } from "./Suborder.vue?vue&type=template&id=6365d25c&scoped=true"
import script from "./Suborder.vue?vue&type=script&lang=js"
export * from "./Suborder.vue?vue&type=script&lang=js"
import style0 from "./Suborder.vue?vue&type=style&index=0&id=6365d25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6365d25c",
  null
  
)

export default component.exports